export default {
	data() {
		return {
			levelType: 0,
			preUrl: "",
			delAllUrl: "",
			delUrl: "",
			addUrl: "",
			editStatusUrl: "",
			page: {
				current: 1,
				sizes: [10, 20, 50, 100, 200],
				size: 50,
				total: 0
			},
			search: '',
			toid:0,
			prop: 'create_time',
			sort: 'descending',
			isUpdateNum: false,
			tableHeight:0,
			observer:null,
			multipleSelection: [],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	filters: {
		numToString(value) {
			return value.toString();
		}
	},
	created() {
		if (typeof this.$route.params.toid != 'undefined') {
			this.toid = this.$route.params.toid
		}
		if (typeof this.$route.params.search != 'undefined') {
			this.search = this.$route.params.search
		}
		
		this.getList()
	},
	mounted() {
		this.observer = new ResizeObserver(entries => {
			for (let entry of entries) {
				//console.log('searchDiv height:', entry.contentRect.height);
				// 處理高度变化後的逻辑
				this.getSearchDivHeight()
			}
		});
		if (this.$refs.searchDiv) {
			this.observer.observe(this.$refs.searchDiv);
		} else {
			console.error("searchDiv 元素未能找到");
		}
	},
	beforeDestroy() {
	  if (this.observer) {
	    this.observer.disconnect();
	  }
	},
	computed: {
		// 选中記錄id組成的數組
		ids() {
			return this.multipleSelection.map(item => {
				return item.id
			})
		}
	},
	methods: {
		getSearchDivHeight() {
		  if (this.$refs.searchDiv) {
			  let searchH = this.$refs.searchDiv.offsetHeight;
				this.tableHeight = window.innerHeight - searchH - 200;
		  }
		},
		// 搜索
		searchEvent(e = false) {
			// 簡單搜索
			if (typeof e === 'string') {
				this.search = e;
				this.getList()
				return
				//return console.log('簡單搜索')
			}
			this.search = this.from
			this.getList()
			//console.log(this.from);
			// 高級搜索
			//console.log('高級搜索')
		},
		showExpress(data){
			this.layout.showExpressModel(data);
		},
		// 多选
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleSizeChange(val) {
			this.page.size = val
			//console.log(`每页 ${val} 条`);
			this.getList()
		},
		sortChange(column){
			this.prop = column.prop
			this.sort = column.order
			this.getList()
		},
		handleCurrentChange(val) {
			this.page.current = val
			this.getList()
			//console.log(`當前页: ${val}`);
		},
		// 處理列表结果
		getListResult(data) {

		},

		// 获取請求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}`
		},
		handleClick(tab, event) {
			this.search = ''
			this.getList()
		},

		//获取列表
		getList() {
			
			if (this.preUrl == '') return
			this.layout.loading = true;
			this.axios.post(this.getListUrl(), {
				page: this.page.current,
				limit: this.page.size,
				search: this.search,
				prop: this.prop,
				type: this.type,
				toid:this.toid,
				sort: this.sort == 'ascending' ? 'asc' : 'desc'
			}, {
				token: true,
				loading: true
			}).then(res => {
				let all = res.data
				let list = all.data.list

				this.page.total = list.total
				this.toid = 0
				//this.tableData = list.list
				this.getListResult(list)
				this.getSearchDivHeight();
				this.layout.loading = false;
			}).catch(err => {
				// 失敗
				console.log(err);
				this.layout.loading = false;
			})
		},
		// 添加/修改url
		changeStatusUrl() {
			return `/admin/${this.editStatusUrl}`
		},
		// 修改狀態
		changeStatus(item, type = 1, showAlert = true, is_update = false) {
			let status = 0;
			// 根据類型判断狀態
			if (type === 2) {
				status = item.is_show === 1 ? 0 : 1;
			} else if (type === 3) {
				status = item.is_login === 1 ? 0 : 1;
			} else if (type === 4) {
				status = item.is_home === 1 ? 0 : 1;
			} else if (type === 5) {
				status = item.is_service === 1 ? 0 : 1;
			} else if (type === 6) {
				status = item.is_home_bottom === 1 ? 0 : 1;
			} else if (type === 7) {
				status = item.is_top === 1 ? 0 : 1;
			} else {
				status = item.status === 1 ? 0 : 1;
			}

			let msg = status === 1 ? '啟用' : '禁用';
			this.layout.loading = false;
			this.axios.post(this.changeStatusUrl(), {
				id: item.id,
				status: status,
				type: type,
				page_type: this.type
			}, {
				token: true
			}).then(res => {
				let all = res.data;
				if (all.code == 1) {
					if (type === 2) {
						item.is_show = status;
					} else if (type === 3) {
						item.is_login = status;
					} else if (type === 4) {
						item.is_home = status;
					} else if (type === 5) {
						this.getList();  // 重新获取列表
						item.is_service = status;
					} else if (type === 6) {
						item.is_home_bottom = status;
					} else if (type === 7) {
						item.is_top = status;
					} else {
						item.status = status;
					}

					if (showAlert) {
						this.$message({
							message: msg + '成功',
							type: 'success'
						});
					}
					if (is_update) {
						this.layout.getPageNum();
					}

				}
				this.createModel = false;
			}).catch(err => {
				this.createModel = false;
				if (showAlert) {
					this.$message.error('操作失敗');
				}
			});
		},

		// 添加/修改url
		addOrEditUrl() {
			return `/admin/${this.addUrl}`
		},
		//添加/修改
		addOrEdit(data, is_update = false, showAlert = true, showLoading = true) {
			if (showLoading) {
				this.layout.loading = true;  // 控制加載层的顯示
			}

			this.axios.post(this.addOrEditUrl(), data, {
				token: true
			}).then(res => {
				let all = res.data;
				if (all.code == 1) {
					if (showAlert) {
						this.$message({
							message: all.msg,
							type: 'success'
						}); // 控制是否顯示成功提示
					}
					this.createModel = false;
					if (is_update) {
						this.layout.getPageNum();
					}
				}
				this.getList();
				this.submitLoading = false
				if (showLoading) {
					this.layout.loading = false;  // 控制加載层的隐藏
				}
			}).catch(err => {
				this.submitLoading = false
				if (showLoading) {
					this.layout.loading = false;  // 控制加載层的隐藏
				}
			});
		},

		// 批量删除url
		deleteAllUrl() {
			return `/admin/${this.delAllUrl}`
		},
		// 批量删除
		deleteAll() {
			if (this.ids.length === 0) {
				return this.$message({
					message: '請先选中需要删除的數据',
					type: 'error'
				});
			}
			this.$confirm('是否要删除选中數据?', '提示', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.layout.loading = true;
				let url = this.deleteAllUrl()
				this.axios.post(url, {
					ids: this.ids,
					type: this.type
				}, {
					token: true,
					loading: true
				}).then(res => {

					this.multipleSelection = []
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					console.log(1);
					this.getList()

					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				})
			})
		},
		// 删除url
		deleteUrl() {
			return `/admin/${this.delUrl}`
		},
		// 删除單个
		deleteItem(item) {
			this.$confirm('是否要刪除該數據?', '提示', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.layout.loading = true;
				this.axios.post(this.deleteUrl(), {
					id: item.id,
					type: this.type
				}, {
					token: true
				}).then(res => {
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.getList()
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				})
			})
		},
	}
}
